// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"9":"settings/offers","49":"settings/stream","294":"detail/withdraw","416":"promo"}[chunkId] || chunkId) + "." + {"9":"069d1282","49":"8deb216b","294":"10afd5ad","416":"59c418ed","921":"fa5ea412"}[chunkId] + ".css";
};